export const experienceData = [
  {
    name: "Lê Nhật Phong",
    position: "PCN nhiệm kỳ 2021-2022",
    img: "./imgExperience/le nhat phong.jpg",
    content:
      "Trải nghiệm của anh khi tham gia vào CLB là được làm quen với các anh chị khóa trên, các bạn, các lứa khóa sau, mỗi lưá anh đều được học những thứ khác nhau, ngoài được truyền cảm hứng tìm tòi học hỏi về công nghệ",
  },
  {
    name: "Phạm Hoàng Thắng",
    position: "Trưởng nhóm Điện tử 2020-2021",
    img: "./imgExperience/pham hoang thang.jpg",
    content:
      "Mỗi môn học trong chương trình đào tạo đều có một mặt rất thú vị của riêng nó. Hy vọng qua buổi workshop sắp tới, mỗi bạn đều tìm thấy được một sự thích thú nhất định trong quá trình học tập và làm việc.",
  },
  {
    name: "Nguyễn Thùy Nhiên",
    position: "Trưởng nhóm Nhúng/IOT 2020-2021",
    img: "./imgExperience/nguyen thuy nhien.jpg",
    content:
      "Hãy học từ sai lầm và kinh nghiệm của những người đi trước nha các bạn! Một buổi chia sẻ các kiến thức chuẩn bị hành trang để bước vào môi trường doanh nghiệp cho các bạn sinh viên thì còn gì bằng nhỉ? Lên lịch hẹn cùng Pioneer nhé ",
  },
  {
    name: "Đỗ Tuấn Sơn",
    position: "Trưởng nhóm AI 2021-2022",
    img: "./imgExperience/do tuan son.jpg",
    content:
      "Thời đi học thì việc tập trung cố gắng đạt điểm cao ở các môn học có thể giúp các em nổi bật trong mắt các thầy cô, nhưng liệu nó có thực sự quá quan trọng đối với nhà tuyển dụng nếu như em quyết định đi làm thay vì học lên thạc sĩ, tiến sĩ ? Vậy thì em nên xin đi thực tập? Hay là chỉ học những môn cần thiết khi đi làm ngành mà em thích ?",
  },
];
